export const FETCH_SPLASH_RAND = 'FETCH_SPLASH_RAND';
export const FETCH_AVATAR_RAND = 'FETCH_AVATAR_RAND';



// WEBPACK FOOTER //
// ./src/store/asset/types.js